import { render, staticRenderFns } from "./boot-modal.vue?vue&type=template&id=ba191648&scoped=true"
import script from "./boot-modal.vue?vue&type=script&lang=js"
export * from "./boot-modal.vue?vue&type=script&lang=js"
import style0 from "./boot-modal.vue?vue&type=style&index=0&id=ba191648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba191648",
  null
  
)

export default component.exports